import React from "react"
import { DarkModeProvider } from "../utils/darkMode"

export default function PageRoot({ element }) {
  return <DarkModeProvider>{element}</DarkModeProvider>
}

